"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEnrollmentContext = exports.ILEnrollmentProvider = exports.ILEnrollmentContext = void 0;
var react_1 = __importDefault(require("react"));
var config_provider_1 = require("../config/config.provider");
var services_1 = require("../../services");
var date_fns_1 = require("date-fns");
var ILEnrollmentContext = react_1.default.createContext({});
exports.ILEnrollmentContext = ILEnrollmentContext;
function useEnrollmentContext() {
    // get the context
    var context = react_1.default.useContext(ILEnrollmentContext);
    // if `undefined`, throw an error
    if (!context.dayAssignmentList) {
        throw new Error("useEnrollmentContext must be inside 'ILEnrollmentProvider'");
    }
    return context;
}
exports.useEnrollmentContext = useEnrollmentContext;
function ILEnrollmentProvider(_a) {
    var _this = this;
    var children = _a.children, defaultContext = _a.defaultContext;
    var today = new Date();
    var configState = react_1.default.useContext(config_provider_1.ConfigContext);
    var enrollmentService = react_1.default.useCallback(function () { return new services_1.OtkEnrollmentService(configState.service); }, [configState]);
    var _b = react_1.default.useState((defaultContext === null || defaultContext === void 0 ? void 0 : defaultContext.studentsEvents) || {}), studentsEvents = _b[0], setStudentEvents = _b[1];
    var _c = react_1.default.useState((defaultContext === null || defaultContext === void 0 ? void 0 : defaultContext.dayAssignmentList) || []), dayAssignmentList = _c[0], setDayAssignmentList = _c[1];
    var _d = react_1.default.useState((defaultContext === null || defaultContext === void 0 ? void 0 : defaultContext.schoolSchedule) || {}), schoolSchedule = _d[0], setSchoolSchedule = _d[1];
    var _e = react_1.default.useState((defaultContext === null || defaultContext === void 0 ? void 0 : defaultContext.dateWindow) ||
        { start: (0, date_fns_1.subDays)(today, 45), end: (0, date_fns_1.addDays)(today, 45) }), dateWindow = _e[0], setDateWindow = _e[1];
    var cacheStr = react_1.default.useMemo(function () { return "".concat((0, date_fns_1.format)(dateWindow.start, 'yyyy-MM-dd'), "#").concat((0, date_fns_1.format)(dateWindow.end, 'yyyy-MM-dd')); }, [dateWindow.end, dateWindow.start]);
    var cache = react_1.default.useState(new Map())[0];
    var fetchSchoolScheduleCallback = react_1.default.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var schedule, _loop_1, _i, _a, _b, k, v;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    schedule = cache.get(cacheStr);
                    if (!!schedule) return [3 /*break*/, 2];
                    return [4 /*yield*/, enrollmentService().getSchoolSchedule(dateWindow.start, dateWindow.end)];
                case 1:
                    schedule = _c.sent();
                    cache.set(cacheStr, schedule);
                    _c.label = 2;
                case 2:
                    _loop_1 = function (k, v) {
                        setStudentEvents(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[k] = v.events, _a)));
                        });
                    };
                    for (_i = 0, _a = Object.entries(schedule !== null && schedule !== void 0 ? schedule : {}); _i < _a.length; _i++) {
                        _b = _a[_i], k = _b[0], v = _b[1];
                        _loop_1(k, v);
                    }
                    setSchoolSchedule(function (prev) { return (__assign(__assign({}, prev), schedule)); });
                    return [2 /*return*/];
            }
        });
    }); }, [enrollmentService, dateWindow, cache]);
    react_1.default.useEffect(function () {
        var schedule = cache.get(cacheStr);
        setSchoolSchedule(function (prev) { return (__assign(__assign({}, prev), schedule)); });
    }, [cache, cacheStr]);
    react_1.default.useEffect(function () {
        fetchSchoolScheduleCallback();
    }, [fetchSchoolScheduleCallback]);
    var updateStudentData = react_1.default.useCallback(function (student, rescheduleData) { return __awaiter(_this, void 0, void 0, function () {
        var schedule, studentSchedule, overdues;
        return __generator(this, function (_a) {
            schedule = schoolSchedule;
            studentSchedule = schedule[student.guid];
            overdues = studentSchedule.overdueActivities.filter(function (activity) { return activity.courseId !== rescheduleData.courseId; });
            studentSchedule.activities = __spreadArray(__spreadArray([], studentSchedule.activities, true), studentSchedule.overdueActivities.filter(function (activity) { return activity.courseId === rescheduleData.courseId; }), true);
            studentSchedule.activities.forEach(function (activity) {
                var _a;
                if (activity.courseId === rescheduleData.courseId) {
                    activity.isOverdue = false;
                    activity.assignedDate = (0, date_fns_1.format)((_a = rescheduleData.startDate) !== null && _a !== void 0 ? _a : new Date(), 'yyyy-MM-dd');
                    activity.completedDate = undefined;
                }
            });
            schedule[student.guid].overdueActivities = overdues;
            cache.set(cacheStr, schedule);
            setSchoolSchedule(function (prev) { return (__assign(__assign({}, prev), schedule)); });
            return [2 /*return*/];
        });
    }); }, [cache, cacheStr, schoolSchedule]);
    var updateCourseScheduleData = react_1.default.useCallback(function (student, rescheduleData, courseName) { return __awaiter(_this, void 0, void 0, function () {
        var courseId;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    courseId = (_a = schoolSchedule[student.guid].overdueActivities.find(function (activity) {
                        return activity.courseId === rescheduleData.courseId ||
                            activity.activityId === rescheduleData.courseId;
                    })) === null || _a === void 0 ? void 0 : _a.courseId;
                    if (!courseId) return [3 /*break*/, 4];
                    return [4 /*yield*/, enrollmentService().updateCourseScheduleData(student.guid, courseId, {
                            courseId: courseId,
                            courseTitle: courseName,
                            endDate: rescheduleData.endDate,
                            schoolDays: rescheduleData.schoolDays,
                            startDate: rescheduleData.startDate,
                            studentId: student.guid,
                        })];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, updateStudentData(student, __assign(__assign({}, rescheduleData), { courseId: courseId }))];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, fetchSchoolScheduleCallback()];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); }, [enrollmentService, fetchSchoolScheduleCallback, schoolSchedule, updateStudentData]);
    var enrollmentProviderValue = react_1.default.useMemo(function () { return ({
        updateDayAssignmentList: setDayAssignmentList,
        dayAssignmentList: dayAssignmentList,
        schoolSchedule: schoolSchedule,
        fetchSchoolSchedule: fetchSchoolScheduleCallback,
        updateDateWindow: setDateWindow,
        dateWindow: dateWindow,
        updateCourseScheduleData: updateCourseScheduleData,
        studentsEvents: studentsEvents,
        updateStudentsEvents: setStudentEvents,
    }); }, [
        dayAssignmentList,
        schoolSchedule,
        fetchSchoolScheduleCallback,
        dateWindow,
        updateCourseScheduleData,
        studentsEvents,
    ]);
    return (react_1.default.createElement(ILEnrollmentContext.Provider, { value: enrollmentProviderValue }, children));
}
exports.ILEnrollmentProvider = ILEnrollmentProvider;
